import { ChevronLeft, ChevronRight, X } from 'lucide-react';

const SC_BASE = 'https://w.soundcloud.com/player/?url=';
const SC_PARAMS = '&color=%23b89060&auto_play=true&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false';

export default function NowPlaying({ work, trackIndex, onTrackChange, onClose }) {
  const track = work.tracks[trackIndex];
  const multi = work.tracks.length > 1;

  const prev = () => onTrackChange(trackIndex > 0 ? trackIndex - 1 : work.tracks.length - 1);
  const next = () => onTrackChange(trackIndex < work.tracks.length - 1 ? trackIndex + 1 : 0);

  return (
    <div className="now-playing" data-testid="now-playing-bar">
      <div className="now-playing-header">
        <div className="now-playing-info">
          <div className="now-playing-eq" aria-hidden="true">
            <span /><span /><span />
          </div>
          <span className="now-playing-type">{work.type}</span>
          <span className="now-playing-track display">{track.name}</span>
        </div>
        <div className="now-playing-controls">
          {multi && (
            <div className="now-playing-nav" data-testid="now-playing-nav">
              <button onClick={prev} aria-label="Previous track" data-testid="now-playing-prev">
                <ChevronLeft size={14} />
              </button>
              <span className="now-playing-counter">{trackIndex + 1} / {work.tracks.length}</span>
              <button onClick={next} aria-label="Next track" data-testid="now-playing-next">
                <ChevronRight size={14} />
              </button>
            </div>
          )}
          <button className="now-playing-close" onClick={onClose} aria-label="Close player" data-testid="now-playing-close">
            <X size={18} />
          </button>
        </div>
      </div>
      <div className="now-playing-player">
        <iframe
          key={track.url}
          title={`Now Playing — ${track.name}`}
          width="100%"
          height="80"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src={`${SC_BASE}${encodeURIComponent(track.url)}${SC_PARAMS}`}
        />
      </div>
    </div>
  );
}
